import React, { useCallback, useEffect } from 'react';
import { View, Text } from 'react-native';
import { fetchSubscriptions } from '@/services/fetchSubscriptions';
import { usePersistSecureBoundStore } from '@/services/zustand/Store';

export default function SubscribeComponent() {
    const user = usePersistSecureBoundStore(useCallback((state) => state.user, []));

    useEffect(() => {
        const loadSubscriptions = async () => {
            try {
                if (user !== null) {
                    user.subscriptions = await fetchSubscriptions(user.id);
                }
            } catch (error) {
                console.error('Failed to fetch subscriptions:', error);
            }
        };

        loadSubscriptions();
    }, []);

    return (
        <View>
            <Text style={{ color: '#fff', fontSize: 40, alignSelf: 'center', marginTop: 30 }}>Zugriff verweigert!</Text>
            <Text style={{ color: '#fff', fontSize: 20, alignSelf: 'center', marginTop: 30 }}>Deine Abos:</Text>
            {user && user.subscriptions && user.subscriptions.length === 0 ? (
                <Text style={{ color: '#fff', fontSize: 20, alignSelf: 'center' }}>Du hast keine aktiven Abos</Text>
            ) : null}
            {user && user.subscriptions &&  user.subscriptions.map((subscription) => (
                <View style={{ marginBottom: 20 }}>
                    {subscription.type ? (<Text style={{ color: '#fff' }}>Type: {subscription.type}</Text>) : null}
                    {subscription.weekday?.length !== 0 ? (<Text style={{ color: '#fff' }}>Weekday: {subscription.weekday?.join('; ')}</Text>) : null}
                    {subscription.edition?.length !== 0 ? (<Text style={{ color: '#fff' }}>Edition: {subscription.edition?.join(', ')}</Text>) : null}
                    {subscription.magazine ? (<Text style={{ color: '#fff' }}>Magazine: {subscription.magazine}</Text>) : null}
                    {subscription.start ? (<Text style={{ color: '#fff' }}>Start: {subscription.start}</Text>) : null}
                    {subscription.end ? (<Text style={{ color: '#fff' }}>End: {subscription.end}</Text>) : null}
                </View>
            ))}
            <Text style={{ color: '#fff', fontSize: 30, alignSelf: 'center', marginTop: 30 }}>hier ein Abo kaufen!</Text>
        </View>
    );
}
